import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const network = process.env.VUE_APP_NET;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "px-4 py-2 rounded shadow bg-primary text-white",
    target: "_blank",
    href: `https://explorer.stacks.co/txid/${_unref(route).params.id}?chain=${_unref(network)}`
  }, "View Transaction", 8, _hoisted_1))
}
}

})